import { Card, CardContent, CardTitle } from "@/components/ui/card";
import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";
import { CartesianGrid, Line, LineChart, XAxis, YAxis } from "recharts";
import { useEffect, useState } from "react";
import axiosInstance from "@/utils/axiosInstance";

const chartConfig = {
  revenue: {
    label: "Revenue",
    color: "black"
  }
}

const CommisionRevenue = ({ range }: { range: { startDate: Date, endDate: Date } }) => {
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    const getCommisions = async () => {
      const { data } = await axiosInstance.get("/reports/my-commisions", {
        params: {
          startDate: range.startDate.toISOString().split("T")[0],
          endDate: range.endDate.toISOString().split("T")[0],
        },
      });

      setChartData(data)
    };

    getCommisions()
  }, [range]);
  return (
    <Card className="max-w-full">
      <CardContent>
        <CardTitle>Your commisions</CardTitle>
        <ChartContainer config={chartConfig} className="min-h-[200px] w-full">
          <LineChart data={chartData} margin={{left: -20, bottom: -10, top: 20}}>
            <ChartTooltip content={<ChartTooltipContent />} />
            <CartesianGrid
                          strokeDasharray="3 3"
                          vertical={false} 
                          stroke="#e5e7eb" 
                        />
            
                        <XAxis
                          dataKey="month"
                          orientation="bottom"
                          tick={{ fontSize: 12 }}
                          axisLine={false}
                          tickLine={false}
                        />
            
                        <YAxis
                          dataKey="revenue"
                          tick={{ fontSize: 12 }}
                          axisLine={false}
                          tickLine={false}
                        />
            <Line
              dataKey="revenue"
              fill="var(--color-revenue)"
              stroke="var(--color-revenue)"
            />
          </LineChart>
        </ChartContainer>
      </CardContent>
    </Card>
  );
};

export default CommisionRevenue;
